// extracted by mini-css-extract-plugin
export default {"descriptionText":"ResponsiblePicker_descriptionText__Il+gr","errorText":"ResponsiblePicker_errorText__MpiPY"};